const c = {
  name: "Security",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,20v3h2v-3H19z"/>
		<path class="st0" d="M25,17h-2v-1c0-1.7-1.3-3-3-3s-3,1.3-3,3v1h-2v9h10V17z M17,19h6v5h-6V19z M19,17v-1c0-0.5,0.5-1,1-1
			c0.5,0,1,0.5,1,1v1H19z"/>
		<path class="st0" d="M17,3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.3-0.8,2.4-2,2.8V8c2.6,0.2,4.9,1.2,6.7,2.8l1.6-1.6
			C29.1,8.9,29,8.4,29,8c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-0.5,0-0.9-0.1-1.3-0.3l-1.6,1.6c1.6,1.9,2.6,4.2,2.8,6.7
			h2.2c0.4-1.2,1.5-2,2.8-2c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2H32c-0.2,2.6-1.2,4.9-2.8,6.7l1.6,1.6
			c0.4-0.2,0.8-0.3,1.3-0.3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-0.5,0.1-0.9,0.3-1.3l-1.6-1.6
			c-1.9,1.6-4.2,2.6-6.7,2.8v2.2c1.2,0.4,2,1.5,2,2.8c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V32
			c-2.6-0.2-4.9-1.2-6.7-2.8l-1.6,1.6c0.2,0.4,0.3,0.8,0.3,1.3c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3
			c0.5,0,0.9,0.1,1.3,0.3l1.6-1.6C9.3,25.9,8.3,23.6,8,21H5.8c-0.4,1.2-1.5,2-2.8,2c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3
			c1.3,0,2.4,0.8,2.8,2H8c0.2-2.6,1.2-4.9,2.8-6.7l-1.6-1.6C8.9,10.9,8.4,11,8,11c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3
			c0,0.5-0.1,0.9-0.3,1.3l1.6,1.6C14.1,9.3,16.4,8.3,19,8V5.8C17.8,5.4,17,4.3,17,3z M20,2c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1
			c0.6,0,1-0.4,1-1C21,2.4,20.6,2,20,2z M10,20c0,5.5,4.5,10,10,10s10-4.5,10-10c0-5.5-4.5-10-10-10S10,14.5,10,20z M2,20
			c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1s-0.4-1-1-1C2.4,19,2,19.4,2,20z M20,36c-0.6,0-1,0.4-1,1s0.4,1,1,1c0.6,0,1-0.4,1-1
			S20.6,36,20,36z M36,20c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1S36,19.4,36,20z M7,8c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1
			c0-0.6-0.4-1-1-1C7.4,7,7,7.4,7,8z M8,31c-0.6,0-1,0.4-1,1s0.4,1,1,1c0.6,0,1-0.4,1-1S8.5,31,8,31z M31,32c0,0.6,0.4,1,1,1
			c0.6,0,1-0.4,1-1s-0.4-1-1-1C31.5,31,31,31.5,31,32z M32,7c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1C33,7.4,32.6,7,32,7z
			"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Security
};
